import { apiClient } from '../client.ts';

interface OAuthLoginResponse {
  url: string;
  state: string;
}

interface User {
  id: string;
  username: string;
  displayName: string;
  email: string;
  avatarUrl: string;
  role: string;
  hasGithubToken?: boolean;
}

interface AuthResponse {
  user: User;
  accessToken: string;
  refreshToken: string;
}

interface UserSettings {
  id: string;
  hasPersonalAccessToken: boolean;
  hasGithubAccessToken: boolean;
  hasGithubToken: boolean;
  isActive: boolean;
}

export async function initiateOAuthLogin(): Promise<OAuthLoginResponse> {
  return apiClient.post<OAuthLoginResponse>('/auth/github/login');
}

export async function exchangeOAuthCode(code: string): Promise<AuthResponse> {
  return apiClient.post<AuthResponse>('/auth/oauth/exchange', { code });
}

export async function registerWithPassword(
  username: string,
  password: string,
  email?: string,
): Promise<AuthResponse> {
  return apiClient.post<AuthResponse>('/auth/register', { username, password, email });
}

export async function loginWithPassword(username: string, password: string): Promise<AuthResponse> {
  return apiClient.post<AuthResponse>('/auth/login', { username, password });
}

export async function getCurrentUser(): Promise<User> {
  const result = await apiClient.get<{ user: User }>('/auth/me');
  return result.user;
}

export async function logout(refreshToken: string): Promise<void> {
  await apiClient.post('/auth/logout', { refreshToken });
}

export async function getUserSettings(): Promise<UserSettings> {
  return apiClient.get<UserSettings>('/users/settings');
}

export async function updateUserSettings(data: {
  personalAccessToken?: string;
}): Promise<{ success: boolean }> {
  return apiClient.patch<{ success: boolean }>('/users/settings', data);
}
